import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import './Navbar.css';
import ThemeToggle from './ThemeToggle';
import { ThemeContext } from '../context/ThemeContext';

const Navbar = () => {
  const { theme } = useContext(ThemeContext);
  
  return (
    <nav className={`navbar ${theme}`}>
      <h1>Financial Calculators</h1>
      <ul>
        
        <li>
          <Link to="/mortgage">Mortgage Calculator</Link>
        </li>
        <li>
          <Link to="/mortgage/refinance">Refinance Calculator</Link>
        </li>
        <li>
          <Link to="/mortgage/payment">Payment Estimator</Link>
        </li>
        <li>
          <Link to="/mortgage/affordability">Affordability Calculator</Link>
        </li>
        <li>
          <Link to="/savings">Savings Calculator</Link>
        </li>
      </ul>
      <ThemeToggle />
    </nav>
  );
};

export default Navbar;
